export const handleHighChartsExport = (exportType, chartRef, data) => {

  const solidColors = ['#F7D94C', '#6C8CFF', '#EB5757', '#C4C6CC'];

  switch (exportType?.id) {
    case 'pdf':
      chartRef.current?.chart?.exportChart(
        {
          type: 'application/pdf',
          filename: data?.title
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            borderWidth: 2,
            borderColor: '#E0E0E0',
            borderRadius: 16,
            marginTop: 100,
            marginLeft: 60,
            marginRight: 40,
            marginBottom: 60
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 10,
            y: 20,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 10,
            y: 45,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          yAxis: {
            labels: {
              style: { color: '#6E7686', fontSize: '13px' }
            }
          },
          series: [
            {
              colorByPoint: true,
              colors: solidColors,
              borderRadius: 3,
              dataLabels: {
                enabled: true,
                style: { fontWeight: 'bold', color: 'black' }
              }
            }
          ],
          exporting: {
            chartOptions: {
              series: [
                {
                  colorByPoint: true,
                  colors: solidColors,
                  borderRadius: 3,
                  dataLabels: {
                    enabled: true,
                    style: { fontWeight: 'bold', color: 'black' }
                  }
                }
              ],
              legend: {
                enabled: true,
                floating: false,
                adjustChartSize: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemMarginTop: 8,
                itemMarginBottom: 8
              },
              chart: {
                marginTop: 120,
                marginLeft: 60,
                marginRight: 40,
                marginBottom: 60
              }
            }
          }
        }
      );
      break;

    case 'img':
      chartRef.current?.chart?.exportChart(
        {
          type: 'image/png',
          filename: data?.title
        },
        {
          chart: {
            backgroundColor: '#FFFFFF',
            borderWidth: 2,
            borderColor: '#E0E0E0',
            borderRadius: 16,
            marginTop: 100,
            marginLeft: 60,
            marginRight: 40,
            marginBottom: 60
          },
          title: {
            text: data?.title,
            align: 'left',
            x: 10,
            y: 20,
            style: {
              fontSize: '20px',
              fontWeight: 'bold',
              color: '#0B1F35'
            }
          },
          subtitle: {
            text: data?.subTitle,
            align: 'left',
            x: 10,
            y: 45,
            style: {
              fontSize: '14px',
              color: '#4F5B67'
            }
          },
          yAxis: {
            labels: {
              style: { color: '#6E7686', fontSize: '13px' }
            }
          },
          exporting: {
            chartOptions: {
              legend: {
                enabled: true,
                floating: false,
                adjustChartSize: true,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                itemMarginTop: 8,
                itemMarginBottom: 8
              },
              chart: {
                marginTop: 120,
                marginLeft: 60,
                marginRight: 40,
                marginBottom: 60
              }
            }
          }
        }
      );
      break;

    case 'xls':
      chartRef.current?.chart?.exportChart({ type: 'image/svg+xml' });
      const chart = chartRef.current?.chart;
      const csv = chart?.getCSV();
      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `${data?.title}.csv`);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      break;

    default:
      break;
  }
};